import { gql } from '@apollo/client'

export const CHEQUES_QUERY = gql`
  query Cheques($id: bigint!) {
    cheques: d4_partchequecoproprietaire(
      order_by: [
        { cheque: { bordereauderemisedecheque: { dateimpression: desc } } }
        { cheque: { dateencaissementsouhaite: desc } }
      ]
      where: { coproprietaire_id: { _eq: $id } }
    ) {
      cheque {
        montant
        numero
        dateencaissementsouhaite
        tireurcheque {
          id
          nomtireurcheque
        }
        societeByBanqueId {
          id
          raisonsociale
          lieu
        }
        bordereauderemisedecheque {
          dateimpression
        }
      }
    }
  }
`
